var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeDetalhamentoConexoes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 15.552,
    viewBox: "0 0 22 15.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 22,
    height: 15.552,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 15.552,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M0 4.55200098l2 2c4.97080994-4.96994019 13.02919006-4.96994019 18 0l2-2c-6.07733154-6.0697937-15.92266846-6.0697937-22 0zm6 6l-2-2c3.86839294-3.86019898 10.13160706-3.86019898 14 0l-2 2c-2.76210022-2.75979615-7.23789978-2.75979615-10 0zm2 2l3 3 3-3c-.79490662-.7970581-1.87432861-1.24499512-3-1.24499512s-2.20509338.44793701-3 1.24499512z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDetalhamentoConexoes);
export default __webpack_public_path__ + "static/media/icone-detalhamento-conexoes.2ff8d2ef03eabbc48e55a56a703f66b3.svg";
export { ForwardRef as ReactComponent };